export const sideItemClass = "sidebar__list-item"
